const calendarEvents = () => {
  const buttons = document.querySelectorAll('.js-open-calendar');
  if (buttons) {
    buttons.forEach(element => {
      element.addEventListener('click', () => {
        element.classList.toggle('active');
      });
    });
  }
};
export default calendarEvents;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/modules/calendarEvents.js